export type DatePattern = 'dd/MM/yyyy' | 'MM/dd/yyyy' | 'yyyy/MM/dd'

/* -------------------------------------------------------------------------------------------------
 * Profile Constants
 * -----------------------------------------------------------------------------------------------*/
export const EMPTY = ''

export const DEFAULTS = {
  AREA_UNIT: 'ha',
  DATE_PATTERN: 'dd/MM/yyyy',
  LANGUAGE: 'en',
  LENGTH_UNIT: 'meter',
  WEIGHT_UNIT: 'Kg',
  DENSITY_UNIT: 'Kg/l',
  AREA_DENSITY_UNIT: 'Kg/ha',
  VOLUME_UNIT: 'l',
  COUNTRY_ID: EMPTY,
  REGION_ID: EMPTY,
}

/**
 * Enum for the area unit of preference
 */
export enum PREFERRED_AREA_UNIT {
  ha = '4895bcff-c756-468b-b4e8-40fdcc7d527a',
  ac = '80f06c99-cb7c-4890-9dff-01404d433087',
}

/**
 * Enum for the date format
 */
export const datePatterns: DatePattern[] = ['dd/MM/yyyy', 'MM/dd/yyyy', 'yyyy/MM/dd']
